import { EventBus } from '@/main/eventBus';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { PageMode } from '@/main/utils/pageMode';

export const DmsBaseComponent = PageModeMixin.extend({
	props: {
		span: { type: Number, default: 24 },
		placeholder: String,
		placeholderKey: String,
		labelKey: String,
		labelKeySuffix: { type: String, default: '' },
		label: String,
		titleKey: String,
		title: String,
		disabled: { type: Boolean, default: undefined },
	},
	data() {
		return {
			mode: null as PageMode | null,
			isDisabledByEvent: false,
		};
	},
	computed: {
		pageMode(): PageMode | null {
			return this.mode;
		},
		placeholderText(): string | undefined {
			return this.getText(this.placeholder, this.placeholderKey, this.labelText);
		},
		labelText(): string {
			return this.label || (this.labelKey && this.LocalizeMultiKey(this.labelKey) + this.labelKeySuffix);
		},
		titleText(): string | undefined {
			return this.getText(this.title, this.titleKey, this.labelText, this.LocalizeTitle);
		},
		isDisabled(): boolean {
			if (this.disabled !== undefined) {
				return !!this.disabled;
			}
			return this.isDisabledByEvent || (!this.isEditMode && !this.isCreateMode && !this.isListMode && !this.isSelectList);
		},
		isHiddenLabel(): boolean {
			return this.isListMode || this.isSelectList;
		},
	},
	methods: {
		onModeChanged(mode: PageMode): void {
			this.mode = mode;
		},
		/** method used by event to disable component */
		onDisableEvent(isDisable: boolean): void {
			this.isDisabledByEvent = isDisable;
		},
		getText(value: string, key: string, defaultValue?: string, localizeFn?: Function): string | undefined {
			if (value) {
				return value;
			}
			if (key) {
				return typeof localizeFn === 'function' ? localizeFn(key) : this.Localize(key);
			}
			return defaultValue;
		},
	},
	created() {
		EventBus.$on('Mode', this.onModeChanged);
		EventBus.$on('DisableAll', this.onDisableEvent);
	},
	beforeDestroy() {
		EventBus.$off('Mode', this.onModeChanged);
		EventBus.$off('DisableAll', this.onDisableEvent);
	},
});
